import React, { Fragment } from 'react'

export default function LogsListing(props) {
  const { logs, TableBody, TableHead, wrapperClasses, tableClasses, emptyRecordMsg, showAddNew, AddNewComp, loading, HeaderHeadComponent, uniqueKey, disableTableHover } = props

  return (
    <div className={`overview-table hidden-scroll ${wrapperClasses}`}>
      <table className={`table bg-white ${!disableTableHover && 'table-hover'} ${tableClasses}`}>
        <thead className="text-dark border-bottom border-light border-bottom-2">
          {HeaderHeadComponent && <HeaderHeadComponent />}
          <tr>
            {TableHead.map((head, index) => !head.hideFor && <th key={`${uniqueKey ?? ''}_head_${index}`} scope="col" className={`${head.className}`} {...head.attribute}>
              {head.Component ?
                <head.Component /> :
                head.title
              }
            </th>)}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={TableHead.length} className="text-center loading">
                <span className="spinner-border spinner-border-sm mr-2 text-primary" role="status" aria-hidden="true"/>
                <span className="text-primary font-weight-bold">
                  Loading...
                </span>
              </td>
            </tr>
          ) : (
            <>
              {TableBody ? (
                <>
                  {showAddNew && <AddNewComp />}

                  {logs.length ? (
                    logs.map((log, index) => (
                      <Fragment key={`${uniqueKey ?? ''}_row_${log.id}`}>
                        <TableBody log={log} index={index} />
                      </Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={TableHead.length}
                        className="text-center font-size-18"
                      >
                        {emptyRecordMsg ?? 'No Record Found'}
                      </td>
                    </tr>
                  )}
                </>
              ) : (
                <>{props.children}</>
              )}
            </>
          )}
        </tbody>
      </table>
    </div>
  )
}
